import React, { useState } from 'react';
import {Button, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, makeStyles} from '@material-ui/core';
import CenteredLoader from "../Loading/CenteredLoader";
import { red } from "@material-ui/core/colors"

import DeleteIcon from '@material-ui/icons/Delete';


const accent = red[600];
const hoveredAccent = red[700];

const useStyle = makeStyles(() => ({
    button: {
        float: "right",
        color: accent
    },
    buttonLink: {
        float: "right",
        color: accent,
        '&:hover': {
            color: hoveredAccent,
        }
    },
    buttonClose: {
      float: "left"
    }
}))

function DeleteFaqButton(props) {
  const classes = useStyle();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const toggleDialog = () => setOpen(!open);

  const handleOnDelete = async () => {
    setLoading(true);
    try {
      await props.onDelete();
      setLoading(false);
    } catch(err) {
      console.error("Errore durante la cancellazione della domanda", err);
      setLoading(false);
    }
  }

  return (
    <>
      <IconButton
        className={classes.button}
        onClick={toggleDialog}
      >
        <DeleteIcon/>
      </IconButton>
      
      <Dialog
        open={open}
        onClose={toggleDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Vuoi davvero eliminare la domanda?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{marginBottom: 15}}>
            Non sarà più possibile recuperarla
          </DialogContentText>
          {loading && <CenteredLoader />}
          <Button onClick={toggleDialog} color="primary" variant="contained" className={classes.buttonClose}>
            Chiudi
          </Button>
          <Button onClick={handleOnDelete} className={classes.buttonLink} autoFocus>
            Si, cancella
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default DeleteFaqButton;